const DEFAULT_LOCAL_RAILWAY_URL = 'http://localhost:4003';

export function getRailwayUrl() {
  return import.meta.env.VITE_RAILWAY_URL || DEFAULT_LOCAL_RAILWAY_URL;
}
